import { Button, Image, Spinner, Text, useMediaQuery } from "@chakra-ui/react";
import { HStack } from "@chakra-ui/react";
import { VStack } from "@chakra-ui/react";
import { ArrowBackIcon } from "@chakra-ui/icons";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { KYDEmailTemplate } from "@common/interfaces/KYDCampaign";
import actions from "src/actions";
import { KYDScope } from "@common/interfaces/ICognito";

const CampaignTemplates = ({
  permissions = [],
}: {
  permissions?: KYDScope[];
}) => {
  const [templates, setTemplates] = useState<KYDEmailTemplate[]>([]);
  const isMobile = useMediaQuery("(max-width: 768px)")[0];
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTemplates = async () => {
      setLoading(true);
      const templates = await actions.ADMIN.fetchEmailTemplates();
      setTemplates(templates);
      setLoading(false);
    };
    fetchTemplates();
  }, []);

  if (loading) {
    return <Spinner />;
  }
  return (
    <VStack>
      <VStack alignItems="flex-start" w={"100%"}>
        <Link to="/campaigns">
          <Button
            variant="link"
            color="#888888"
            fontWeight="500"
            fontSize="14px"
            leftIcon={<ArrowBackIcon />}
          >
            All Campaigns
          </Button>
        </Link>
        <Text
          fontSize="24px"
          color="#1A202C"
          overflow="hidden"
          textOverflow="ellipsis"
          lineHeight="30px"
          letterSpacing="-0.72px"
        >
          Select Campaign Template
        </Text>
      </VStack>
      <HStack
        w="100%"
        justifyContent="space-between"
        gap={12}
        wrap={"wrap"}
        alignItems="flex-start"
      >
        {templates.map((template) => {
          return (
            <VStack
              as={Link}
              to={`/campaigns/create?template=${template.type}`}
              key={template.type}
              alignItems={isMobile ? "center" : "flex-start"}
              wrap={isMobile ? "wrap" : "nowrap"}
              w={isMobile ? "calc(50% - 24px)" : "200px"}
              gap={1}
            >
              <Image
                src={template.image_url}
                alt={template.type}
                w={isMobile ? "100%" : "200px"}
                // h={isMobile ? "auto" : "320"}
                border="1px solid rgba(0, 0, 0, 0.1)"
                boxShadow="0px 0px 10px rgba(0, 0, 0, 0.04)"
                borderRadius="4px"
              />
              <Text
                overflow="hidden"
                color="#222"
                textOverflow="ellipsis"
                fontSize="16px"
                fontStyle="normal"
                fontWeight="600"
                // lineHeight="23px"
                letterSpacing="-0.48px"
                marginTop={"auto"}
              >
                {template.name}
              </Text>
              <Text
                overflow="hidden"
                color="rgba(34, 34, 34, 0.80)"
                textOverflow="ellipsis"
                fontSize="12px"
                fontStyle="normal"
                lineHeight="23px"
                letterSpacing="-0.36px"
              >
                {template.description}
              </Text>
            </VStack>
          );
        })}
      </HStack>
    </VStack>
  );
};

export default CampaignTemplates;
